import { CSSObject } from '@emotion/react'
import { colors } from '@opallabs/spectrum'

export const MOBILE = { width: 375, height: 667 }
export const DESKTOP = { width: 900, height: 563, slideWidth: 393 }

const frame: CSSObject = {
  backgroundColor: '#d0dae1',
  borderRadius: 2,
  display: 'flex',
  fontFamily: 'Helvetica',
}

// 375 wide plus 55px gutters each side for the carousel arrows.
const getMobileBaseStyles = (isExpanded: boolean): CSSObject => ({
  display: 'flex',
  flexDirection: 'column',
  width: isExpanded ? 900 : 484,
  minHeight: MOBILE.height,
  height: isExpanded ? 'unset' : 750,
})

// ModularCarousel keeps its "1 of N" indicator above the slide and its sticky
// add button (edit only) below, so the frame is taller than TikTok Video's 563
// or the slide's bottom gets clipped by the carousel viewport. Same chrome
// allowance as the mobile base (750 for a 667 frame).
const getDesktopBaseStyles = (isCompact: boolean): CSSObject => ({
  ...frame,
  flexDirection: 'row',
  height: DESKTOP.height + (isCompact ? 60 : 83),
  width: DESKTOP.width,
})

// TikTok Video's asset pane is a plain block, so the carousel gets the same
// flex column the mobile base provides: the sticky add button centers under
// the slide via its auto margins and rests below it instead of over its
// bottom edge. Sized to the carousel's own footprint (slide + arrow gutters).
const desktopCarousel: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  margin: '0 auto',
  position: 'relative',
  width: DESKTOP.slideWidth + 110,
}

type FrameSize = { width: number; height: number; hasPhoto: boolean }

// The frame TikTokVideo's displays expect from their parent: a fixed box the
// kuiper Asset fills edge to edge.
const getSlideFrameStyles = ({
  width,
  height,
  hasPhoto,
}: FrameSize): CSSObject => ({
  ...frame,
  flexDirection: 'column',
  height,
  position: 'relative',
  width,
  '.kuiper-asset-base': {
    display: 'flex',
    height: '100%',
    inset: 0,
    overflow: 'hidden',
    position: 'absolute',
    width: '100%',
    '&.kuiper-placeholder': {
      backgroundColor: colors.n8.base,
    },
    '.kuiper-asset': {
      backgroundColor: hasPhoto ? 'black' : '#d0dae1',
    },
  },
})

const getPickerStyles = (width: number, height: number): CSSObject => ({
  height,
  width,
})

const styles = {
  desktopCarousel,
  getDesktopBaseStyles,
  getMobileBaseStyles,
  getPickerStyles,
  getSlideFrameStyles,
}

export { styles }
